/**
 * Authorization service
 * @example
 * const authorizationService = new AuthorizationService('https://api.neko.com');
 * const data = await authorizationService.authorize('clientId', 'redirectUri', 'codeChallenge', 'state');
 * const data = await authorizationService.token('code', 'redirectUri', 'clientId', 'codeVerifier', 'username');
 * const data = await authorizationService.me('token');
 */
export class AuthorizationService {
    api;
    getAuthHeader;
    constructor(api, getAuthHeader) {
        this.api = api;
        this.getAuthHeader = getAuthHeader;
    }
    async authorize(clientId, redirectUri, codeChallenge, state) {
        const response = await fetch(`${this.api}/authorize?clientId=${clientId}&redirectUri=${encodeURIComponent(redirectUri)}&codeChallenge=${codeChallenge}&state=${state}`);
        const data = await response.json();
        return data;
    }
    async token(code, redirectUri, clientId, codeVerifier, username, email, grantType, refreshToken) {
        const payload = {
            clientId,
        };
        if (grantType === 'refresh_token') {
            payload.grantType = 'refresh_token';
            payload.refreshToken = refreshToken;
        }
        else {
            payload.grantType = 'authorization_code';
            payload.code = code;
            payload.redirectUri = redirectUri;
            payload.codeVerifier = codeVerifier;
            payload.username = username;
            payload.email = email;
        }
        console.log('Token request payload:', {
            ...payload,
            clientId: clientId.substring(0, 10) + '...',
            refreshToken: refreshToken
                ? refreshToken.substring(0, 10) + '...'
                : '[MISSING]',
            grantType,
            code: code ? '[PRESENT]' : '[MISSING]',
            redirectUri: redirectUri || '[MISSING]',
            codeVerifier: codeVerifier ? '[PRESENT]' : '[MISSING]',
            username: username || '[MISSING]',
            email: email || '[MISSING]',
        });
        const response = await fetch(`${this.api}/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            mode: 'cors',
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        console.log('Token response:', {
            status: response.status,
            ok: response.ok,
            error: !response.ok ? data : undefined,
            data: response.ok
                ? {
                    accessToken: data.accessToken ? '[PRESENT]' : '[MISSING]',
                    refreshToken: data.refreshToken ? '[PRESENT]' : '[MISSING]',
                    expiresIn: data.expiresIn,
                }
                : undefined,
        });
        return data;
    }
    async me(token) {
        const response = await fetch(`${this.api}/me`, {
            mode: 'cors',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return data;
    }
    async verifyZaloLogin(code) {
        const response = await fetch(`${this.api}/verify-zalo-login`, {
            method: 'POST',
            body: JSON.stringify({ code }),
        });
        const data = await response.json();
        return data;
    }
}
//# sourceMappingURL=data:application/json;base64,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